import React, { useCallback, Fragment } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import Categories from './Categories';
import './UthLanding.scss';
import { stringifyEqualityCheck } from './../../utils';
import * as loginSelectors from './../Login/Login.selectors';
import * as loginActions from './../Login/Login.actions';
import Layout from './../Layout';
import { Helmet } from 'react-helmet';

const UthLanding = (props) => {
    /* State to props */
    const user = useSelector(loginSelectors.getUser, stringifyEqualityCheck);
    const platformType = useSelector(loginSelectors.getPlatformType, stringifyEqualityCheck);
    const cxmlData = useSelector(loginSelectors.getCxmlData, stringifyEqualityCheck);

    /* Dispatch to props */
    const dispatch = useDispatch();
    const logout = useCallback((history) => dispatch(loginActions.logout(history)), [dispatch]);

    if (user == null) {
        logout(props.history);
        return null;
    }

    if (platformType == null || platformType !== 'uth') {
        props.history.push('/');
        return null;
    }

    let message = 'Welcome to your online product ordering portal.';
    if (cxmlData.buyer_cookie != null) {
        message = <Fragment>Welcome <span>Coupa User</span> to your online product ordering portal.</Fragment>;
    }

    return (
        <Layout
            title={<Fragment><i className="fas fa-layer-group"></i> Welcome</Fragment>}
            step={1}
            history={props.history}
        >
            <Helmet>
                <title>UTHealth</title>
            </Helmet>
            <div className="uth-landing-container">
                <h2>{message}</h2>
                <h3>Select a product type to begin.</h3>
                <Categories 
                    user={user}
                />
            </div>
        </Layout>
    );
};

UthLanding.propTypes = {

};

export default UthLanding;
